module.exports = __webpack_public_path__ + "img/lock.1977c35d.svg";